import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IModule} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {Språkvalg} from "felles/tjenester/i18n/Spraakvalg";
import {AvtaleRessurs} from "felles/tjenester/ressurser/AvtaleRessurs";
import {MdDialogController} from "../../../../tjenester/Dialog";

const css = require('./lisensavtaleDialog.scss');

export class LisensavtaleDialog {
    static regNavn = "wm.gruppe.modale.lisensavtale.LisensavtaleDialoger";

    static registrerDialog(angular: IModule) {
        angular
            .service(LisensavtaleDialog.regNavn, LisensavtaleDialog.forInjisering())
            .controller(LisensavtaleDialogKontroller.regNavn, LisensavtaleDialogKontroller.forInjisering())
    }

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            LisensavtaleDialog
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService) {
    }

    private dialogKonfigurasjon = {
        template: require('./lisensavtaleDialog.html'),
        controller: LisensavtaleDialogKontroller.regNavn,
        controllerAs: '$ctrl',
        bindToController: true
    };

    visLisensavtaleDialog(callback: (akseptert: LisensavtaleAkseptert) => void) {
        this.$mdDialog.show(this.dialogKonfigurasjon)
            .then(akseptert => callback(akseptert));
    }
}

export interface LisensavtaleAkseptert {
    akseptert: boolean;
    aksepterteBetingelser: string;
}

export class LisensavtaleDialogKontroller implements MdDialogController{
    static regNavn = "wm.gruppe.modale.lisensavtale.LisensavtaleDialogKontroller";

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            AvtaleRessurs.regNavn,
            Språkvalg.regNavn,
            LisensavtaleDialogKontroller
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService, private orgRessurs: AvtaleRessurs, private språkvalg: Språkvalg) {
    }

    betingelser: l.BetingelserModell;
    laster = true;

    aksepter() {
        this.$mdDialog.hide(this.dialogRespons(true));
    }

    avbryt() {
        this.$mdDialog.hide(this.dialogRespons(false));
    }

    print() {
        window.print();
    }

    $onInit(): void {
        this.orgRessurs.hentVilkår(this.språkvalg.aktivtSpråk()).$promise
            .then(betingelser => this.betingelser = betingelser)
            .finally(() => this.laster = false);
    }

    //hjelpemetoder

    private lukkDialog() {
        this.$mdDialog.hide();
    }

    private dialogRespons(akseptert: boolean) {
        console.debug('dialogRespons', akseptert, this.betingelser);
        return {akseptert: akseptert, aksepterteBetingelser: this.betingelser.betingelser};
    }
}
